<template lang="pug">
  main
    NavBarSca
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Configuración TPA
        .columns.has-text-centered
          .column.is-12
            .tabs
              ul
                li(:class="{ 'is-active': tabsel == 'porteadores' }" @click="cambiarTab('porteadores')")
                  a 
                    i.fas.fa-truck-moving
                    | &nbspPorteadores
                li(:class="{ 'is-active': tabsel == 'destinos' }" @click="cambiarTab('destinos')")
                  a 
                    i.fas.fa-map-marker-alt
                    | &nbspDestinos
                li(:class="{ 'is-active': tabsel == 'operadores' }" @click="cambiarTab('operadores')")
                  a 
                    i.fas.fa-user-alt
                    | &nbspOperadores
                li(:class="{ 'is-active': tabsel == 'pg' }" @click="cambiarTab('pg')")
                  a 
                    i.fas.fa-shuttle-van
                    | &nbspAutotanques
                li(:class="{ 'is-active': tabsel == 'dolar' }" @click="cambiarTab('dolar')")
                  a 
                    i.fas.fa-dollar-sign
                    | &nbspDólar
        .columns
          .column.is-12
            ContainerPorteadores(:porteadores="porteadores" v-show="verFormPorteador" @updTBPorteadores="updTBPorteadores")
            ContainerDestinos(:destinos="destinos" v-show="verFormDestino" @updTbDestinos="updTBDestinos")
            ContainerOperadores(:operadores="operadores" v-show="verFormOperador" @updTBOperadores="updTBOperadores")
            ContainerAutotanques(:pg="pg" v-show="verFormAutotanques" @updTBAutotanques="updTBAutotanques")
            FormDolar(v-show="verFormDolar")
</template>

<script>
  import NavBarSca from '@/components/sca_Componentes/layout/tpa/NavBarSca.vue'
  import ContainerPorteadores from './ContainerPorteadores.vue'
  import ContainerDestinos from './ContainerDestinos.vue'
  import ContainerOperadores from './ContainerOperadores.vue'
  import ContainerAutotanques from './ContainerAutotanques.vue'
  import FormDolar from './FormDolar.vue'
  import FormFolio from './FormFolio.vue'
  import Loader from '@/components/shared/Loader.vue'
  import sca_tuxpanServices from '@/services/sca/tpa.js'

  export default {
    name: 'Configuracion_TPA',
    components: { NavBarSca, Loader, ContainerPorteadores, ContainerDestinos, ContainerOperadores, ContainerAutotanques, FormDolar, FormFolio },
    data() {
      return {
        isLoading: true,
        tabsel: 'porteadores',
        verFormPorteador: true,
        verFormDestino: false,
        verFormOperador: false,
        verFormAutotanques: false,
        verFormDolar: false,
        porteadores: [],
        destinos: [],
        operadores:[],
        pg:[],
      }
    },
    methods: {
      iniciarComponente() {
        this.isLoading = true
        this.obtenerPorteadores()
      },
      cambiarTab (tab) {
        this.tabsel = tab
        switch (this.tabsel) {
          case 'porteadores':
            this.verFormPorteador = true
            this.verFormDestino = false
            this.verFormOperador = false
            this.verFormAutotanques = false
            this.verFormDolar = false
            break
          case 'destinos':
            this.verFormPorteador = false
            this.verFormDestino = true
            this.verFormOperador = false
            this.verFormAutotanques = false
            this.verFormDolar = false
            break
          case 'operadores':
            this.verFormPorteador = false
            this.verFormDestino = false
            this.verFormOperador = true
            this.verFormAutotanques = false
            this.verFormDolar = false
            break
          case 'pg':
            this.verFormPorteador = false
            this.verFormDestino = false
            this.verFormOperador = false
            this.verFormAutotanques = true
            this.verFormDolar = false
            break
          case 'dolar':
            this.verFormPorteador = false
            this.verFormDestino = false
            this.verFormOperador = false
            this.verFormAutotanques = false
            this.verFormDolar = true
            break
          default:
            break
        }
      },
      obtenerPorteadores() {
        sca_tuxpanServices.getPorteadores()
          .then( resp => {
            this.porteadores = resp
            this.isLoading = false
            this.obtenerDestinos()
          })
          .catch( e => {
            console.log(e)
            this.isLoading = false
          })
      },
      obtenerDestinos() {
        sca_tuxpanServices.getDestinos()
          .then( resp => {
            this.destinos = resp
            this.isLoading = false
            this.obtenerOperadores()
          })
          .catch( e => {
            console.log(e)
            this.isLoading = false
          })
      },
      obtenerOperadores() {
        sca_tuxpanServices.getOperadores()
          .then( resp => {
            this.operadores = resp
            this.isLoading = false
            this.obtenerAutotanques()
          })
          .catch( e => {
            console.log(e)
            this.isLoading = false
          })
      },
      obtenerAutotanques() {
        sca_tuxpanServices.getAutotanques()
          .then( resp => {
            this.pg = resp
            this.isLoading = false
          })
          .catch( e => {
            console.log(e)
            this.isLoading = false
          })
      },
      
      updTBPorteadores (upd) {
        if (upd) {
          this.obtenerPorteadores()
        }
      },
      updTBDestinos (upd) {
        if (upd) {
          this.obtenerDestinos()
        }
      },
      updTBAutotanques (upd) {
        if (upd) {
          this.obtenerAutotanques()
        }
      },
      updTBOperadores (upd) {
        if (upd) {
          this.obtenerOperadores()
        }
      }
    },
    created () {
      this.iniciarComponente()
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/Configuracion_TPA.vue